import { render, staticRenderFns } from "./ZygoteMultipleChoice.vue?vue&type=template&id=05b476b2&"
import script from "./ZygoteMultipleChoice.vue?vue&type=script&lang=js&"
export * from "./ZygoteMultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./ZygoteMultipleChoice.vue?vue&type=style&index=0&id=05b476b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports